import React from 'react';
import axios from 'axios';
import { Row, Col, Input, Table, Divider, Form, Select, Button } from 'antd';
import apiPath from 'apiPath';
import globalFormItemLayout from 'components/Portal/formItemLayout';
import SaveButton from 'components/SaveButton'
import withSpin from 'components/withSpin';
import moment from 'components/momentWithZone';

const formItemLayout = Object.assign({}, globalFormItemLayout, { labelCol: { sm: { span: 8 } }, wrapperCol: { sm: { span: 16 } } });
const { Column, ColumnGroup } = Table;
const InputGroup = Input.Group;
const { TextArea } = Input;

const sourceOption = [
	{ key: 'Phone', label: 'Phone' },
	{ key: 'Voicemail', label: 'Voicemail' },
	{ key: 'Email', label: 'Email' }
];


class FinancialNote extends React.Component {
	state = {
		noteData: []
	}

	getNotes = () => {
		axios.get(apiPath + '/note/listNotes', { withCredentials: true }).then(result => {
			this.setState({
				noteData: result.data.map(note => {
					note.date =moment(note.date).format('MMMM Do YYYY, h:mm:ss a');
					return note
				})
			});
		})
	}

	handleSubmit = (event) => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				axios.post(apiPath + '/note/postNote', values, { withCredentials: true }).then(result => {
					this.getNotes()
					this.props.form.resetFields();
				})
			}
		})
	}
	componentDidMount() {
		this.getNotes()
	}

	render() {

		const columns = [{
			title: 'Note',
			dataIndex: 'note',
			key: 'note',
			width: '55%'
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
			width: '8%'
		},
		{
			title: 'Source',
			dataIndex: 'source',
			key: 'source',
			width: '8%'
		},
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
			width: '14%'
		},
		{
			title: 'Written By',
			dataIndex: 'user',
			key: 'user',
			width: '15%'
		}
		]

		const noteData = []
		const { getFieldDecorator } = this.props.form;

		return (

			
			<div>			
				<Table
					columns={columns}
					dataSource={this.state.noteData}
					bordered={true}
					rowKey='id'
					size='middle'
					style={{ backgroundColor: 'white' }}
					pagination={false}
					scroll={{ y: 240 }}
					
				/>
				<br />
				<Form onSubmit={this.handleSubmit}>
					<Form.Item label="Note" {...formItemLayout}>
						{getFieldDecorator('note', {

						})(
							<Input />
						)}

					</Form.Item>
					<Form.Item label="Type" {...formItemLayout}>
						{getFieldDecorator('type', {
						})(
							<Select>
								<Select.Option key="Financial">Financial</Select.Option>
							</Select>
						)}
					</Form.Item>
					<Form.Item label="Source" {...formItemLayout}>
						{getFieldDecorator('source', {
						})(
							<Select>
								{sourceOption.map(source => {
									return <Select.Option key={source.key}>{source.label}</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<SaveButton
						loading={this.props.getStatus().submitting} />
				</Form>
			</div>

		);
	}
}
export default withSpin(Form.create()(FinancialNote));


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialNote.jsx